// extracted by mini-css-extract-plugin
export default {"rating":"FinishStage_rating__U2Fms","ratingText":"FinishStage_ratingText__QBI1X","controls":"FinishStage_controls__+wp+y","controlsButton":"FinishStage_controlsButton__UridC"};